/**
 * Eyebrow combined locale — close details on outside click / second combo open.
 */
(() => {
  const closeAll = (except) => {
    document.querySelectorAll('[data-aycan-locale-combo][open]').forEach((combo) => {
      if (combo !== except) combo.open = false;
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-aycan-locale-combo]').forEach((combo) => {
      if (combo.dataset.aycanLocaleComboInit === '1') return;
      combo.dataset.aycanLocaleComboInit = '1';

      combo.addEventListener('toggle', () => {
        if (combo.open) closeAll(combo);
      });
    });
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-aycan-locale-combo][open]').forEach((combo) => {
      if (!combo.contains(event.target)) combo.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.code !== 'Escape') return;
    closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
